module.exports = __webpack_public_path__ + "img/user1.b62ab216.png";